import { useEffect, useState } from "react";

export type useScrollYProps = {
    onScrollChange?: (scrollY: number) => void,
    delay: number
}

export const useScrollY = (props: useScrollYProps) => {
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        let timeout: NodeJS.Timeout;

        const handleScroll = () => {
            // Clear the previous timeout to prevent multiple updates
            clearTimeout(timeout);

            // Set a new timeout to update the scroll position after the specified delay
            timeout = setTimeout(() => {
                setScrollY(window.scrollY);

                if (props?.onScrollChange) {
                    props.onScrollChange(window.scrollY);
                }
            }, props.delay);
        };

        // Attach the scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [props.delay]);

    return scrollY;
}